import { render, staticRenderFns } from "./EmailDashboard.vue?vue&type=template&id=580ab02c&scoped=true"
import script from "./EmailDashboard.vue?vue&type=script&lang=js"
export * from "./EmailDashboard.vue?vue&type=script&lang=js"
import style0 from "./EmailDashboard.vue?vue&type=style&index=0&id=580ab02c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580ab02c",
  null
  
)

export default component.exports